module.exports = __webpack_public_path__ + "img/6_128.fb3157d1.png";